import { IHomeData, IModule, IChannel } from './type';
import { EnumModuleCode, initIcon, initCourseTab, EnumChannelType, LiveStreamingStatus } from './const';

export const getDefaultModuleMap = (originData: IHomeData[], id?: number) => {
  if (!id) return originData?.[0]?.moduleMap as Record<EnumModuleCode, IModule[]>;
  return originData.find((item) => item.id === id)?.moduleMap as Record<EnumModuleCode, IModule[]>;
};

export const getDefaultIcon = (originData: IHomeData[], id?: number) => {
  return getDefaultModuleMap(originData, id)[EnumModuleCode.Icon]?.[0]?.iconList?.[0] || initIcon;
};

export const getDefaultCourseTab = (originData: IHomeData[], id?: number) => {
  return getDefaultModuleMap(originData, id)[EnumModuleCode.Course]?.[0] || initCourseTab;
};

export const getModuleBannerId = (moduleMap: Record<EnumModuleCode, IModule[]>, moduleCode: EnumModuleCode) => {
  return moduleMap?.[moduleCode]?.[0]?.id;
};

export const getDefaultIdByModuleCode = (moduleMap: Record<EnumModuleCode, IModule[]>, moduleCode: EnumModuleCode) => {
  return moduleMap?.[moduleCode]?.[0]?.id;
};

export const getAllPopularCourses = (moduleMap: Record<EnumModuleCode, IModule[]>, moduleCode: EnumModuleCode) => {
  const idList = moduleMap?.[moduleCode].map((c) => c.id);
  return idList;
};

export const getModuleIdList = (moduleMap: Record<EnumModuleCode, IModule[]>) => {
  const moduleIdList: number[] = [];
  const defaultLiveId = getDefaultIdByModuleCode(moduleMap, EnumModuleCode.Live);
  defaultLiveId && moduleIdList.push(defaultLiveId);
  const defaultPopularCourseId = getDefaultIdByModuleCode(moduleMap, EnumModuleCode.PopularCourse);
  defaultPopularCourseId && moduleIdList.push(defaultPopularCourseId);
  const defaultCourseId = getAllPopularCourses(moduleMap, EnumModuleCode.Course);
  defaultCourseId && moduleIdList.push(...defaultCourseId);
  return moduleIdList;
};

export const getModuleMap = (curChannel: IChannel, originData: IHomeData[]): Record<EnumModuleCode, IModule[]> => {
  const { id, tabType } = curChannel;
  const emptyMap = {
    [EnumModuleCode.Icon]: [],
    [EnumModuleCode.Live]: [],
    [EnumModuleCode.PopularCourse]: [],
    [EnumModuleCode.Course]: [],
    [EnumModuleCode.Banner]: [],
  };
  if (tabType === EnumChannelType.Module) {
    return (originData.find((item) => item.id === id)?.moduleMap || emptyMap) as Record<EnumModuleCode, IModule[]>;
  }
  return emptyMap;
};
//
export const getLiveStatus = (isSetRemind, appointmentStatus = false, liveStatus) => {
  if (!appointmentStatus) {
    if (liveStatus === 2) return LiveStreamingStatus.LivePlayback;
    // 直接返回对应的直播状态 如果当前时间小于开播时间
    if (liveStatus === 1) {
      return isSetRemind ? LiveStreamingStatus.LiveCancel : LiveStreamingStatus.LiveReservation;
    }
    if (liveStatus === 0) return LiveStreamingStatus.LiveProgress;

    return;
  }

  // 判断是否结束
  if (liveStatus === 2) return LiveStreamingStatus.End;

  // 判断是否正在直播

  if (liveStatus === 0) return '';

  if (isSetRemind) {
    return '已预约';
  }
  return '未预约';

  // 判断是否登录
};

export const getLiveStatusImg = (liveStatus, isSetRemind) => {
  // 判断是否结束
  if (liveStatus === 2) return 'play';

  // 判断是否正在直播

  if (liveStatus === 0) return 'livestreaming';

  if (isSetRemind) {
    return 'success';
  }
  return 'time';
  // 判断是否登录
};

export const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${month}-${day} ${hours}:${minutes}`;
};
export interface LearningTime {
  today: number;
  cumulative: number;
}
export const learningTimeManagement = (data: LearningTime) => {
  const { today, cumulative } = data;
  const formattedToday = Math.min(Math.round(today / 60), 999);

  // 转为小时并保留一位小数，且如果小时数超过100则不显示小数
  let formattedCumulative = cumulative / 3600;
  if (formattedCumulative > 100) {
    formattedCumulative = Math.floor(formattedCumulative); // 超过100小时不显示小数
  } else {
    formattedCumulative = parseFloat(formattedCumulative.toFixed(1)); // 保留一位小数
  }

  return {
    today: formattedToday,
    cumulative: formattedCumulative,
  };
};

export const nameLength = (value: string | undefined) => {
  const userName = value || '';
  const truncatedName = userName.length > 10 ? `${userName.substring(0, 10)}...` : userName;

  return truncatedName;
};

export const updateCourseListStatus = (courseList, remindCourseIds) => {
  return courseList.map((course) => {
    const updatedCourse = { ...course };

    // 如果提醒课程 ID 列表不为空，检查课程 ID 是否在其中
    if (remindCourseIds.length > 0) {
      updatedCourse.isSetRemind = remindCourseIds.includes(course.id);
    } else {
      // 如果为空，设置所有课程的 isSetRemind 为 false
      updatedCourse.isSetRemind = false;
    }

    return updatedCourse;
  });
};
